import React, { Component } from 'react';
import * as globals from '../globals.js';
import ApiService from '../services/ApiService';
import NotificationService from '../services/NotificationService';
import IntegerInput from './IntegerInput';
import FilteredInput from '../components/FilteredInput';
import InputMask from 'react-input-mask';

export default class AddRelatedPersonForm extends Component {
    constructor() {
        super();

        this.apiService = ApiService.getInstance();
        this.notificationService = NotificationService.getInstance();
        this.state = {value: ''};
        this.state = {
            ParticipantRelationsDVID: '',
            firstName: '',
            lastName: '',
            genderDVID: '',
            dateOfBirdth: '',
            pesel: '',
            street: '',
            building: '',
            flat: '',
            city: '',
            postalCode: '',
            email: '',
            phone: '',
            personalDataProcessingConsent: '',
        };
        const defaultValue = new Date().toISOString().split('T')[0]; 
    }

    handleChange(event) {
        this.setState({value: event.target.value});
      }

    parsePesel(id) {
        // console.log(id)
        let peselN = id;
        if (peselN.toString().length !== 11) {
            return '';
        }
        let rr = '';
        let mm = '';
        let dd = '';
        let rok;
        for (let i = 0; i < peselN.toString().length; i++) {
            if (i <= 1) {
                rr += peselN[i];
            }
            if (i > 1 && i <= 3) {
                mm += peselN[i];
            }
            if (i > 3 && i <= 5) {
                dd += peselN[i];
            }
        }
        if (Number(peselN[2]) === 0 || Number(peselN[2]) === 1) {
            rok = 19 + rr;
        }
        if (Number(peselN[2]) === 2 || Number(peselN[2]) === 3) {
            rok = 20 + rr;
        }
        if (Number(peselN[2]) === 2 || Number(peselN[2]) === 3) {
            rok = 20 + rr;
        }
        if (Number(mm[0]) !== 1) {
            if (Number(mm[0]) === 2) {
                let numM = mm[0];
                numM = 0 + mm[1];
                mm = numM;
            }
            if (Number(mm[0]) === 3) {
                let numM = mm[0];
                numM = 1 + mm[1];
                mm = numM;
            }
        }

        this.dateOfBirdth = rok + '-' + mm + '-' + dd;
        if (this.dateOfBirdth && this.dateOfBirdth !== 'Invalid Date') {
            this.setState({ value: this.dateOfBirdth });
            this.setState({ dateOfBirdth: this.dateOfBirdth })
        }

    }
 
    render() {
        return (
            <>
                <main className="responsive-padding">
                    <div className="row-align-items-center">
                        <svg
                            className="add-releted-icon"
                            width="54"
                            height="37"
                            viewBox="0 0 54 37"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M27 10.25C26.0111 10.25 25.0444 9.95676 24.2221 9.40735C23.3999 8.85794 22.759 8.07705 22.3806 7.16342C22.0022 6.24979 21.9031 5.24446 22.0961 4.27455C22.289 3.30465 22.7652 2.41373 23.4645 1.71447C24.1637 1.01521 25.0546 0.539002 26.0245 0.346076C26.9945 0.15315 27.9998 0.252166 28.9134 0.630605C29.827 1.00904 30.6079 1.64991 31.1573 2.47215C31.7068 3.2944 32 4.2611 32 5.25C31.9987 6.57568 31.4715 7.84668 30.5341 8.78407C29.5967 9.72147 28.3257 10.2487 27 10.25ZM27 2.75C26.5055 2.75 26.0222 2.89662 25.6111 3.17133C25.2 3.44603 24.8795 3.83648 24.6903 4.29329C24.5011 4.75011 24.4516 5.25278 24.548 5.73773C24.6445 6.22268 24.8826 6.66814 25.2322 7.01777C25.5819 7.3674 26.0273 7.6055 26.5123 7.70197C26.9972 7.79843 27.4999 7.74892 27.9567 7.5597C28.4135 7.37048 28.804 7.05005 29.0787 6.63893C29.3534 6.2278 29.5 5.74446 29.5 5.25C29.4993 4.58716 29.2357 3.95166 28.767 3.48297C28.2983 3.01427 27.6628 2.75066 27 2.75ZM43.9444 17.0127C44.6638 17.4934 45.5097 17.75 46.375 17.75C47.5349 17.7487 48.6469 17.2873 49.4671 16.4671C50.2873 15.6469 50.7487 14.5349 50.75 13.375C50.75 12.5097 50.4934 11.6638 50.0127 10.9444C49.5319 10.2249 48.8487 9.66416 48.0492 9.33303C47.2498 9.0019 46.3701 8.91526 45.5215 9.08407C44.6728 9.25288 43.8933 9.66956 43.2814 10.2814C42.6696 10.8933 42.2529 11.6728 42.0841 12.5215C41.9153 13.3701 42.0019 14.2498 42.333 15.0492C42.6642 15.8487 43.2249 16.532 43.9444 17.0127ZM45.3333 11.816C45.6416 11.61 46.0042 11.5 46.375 11.5C46.8721 11.5007 47.3486 11.6984 47.7001 12.0499C48.0516 12.4014 48.2493 12.8779 48.25 13.375C48.25 13.7458 48.14 14.1084 47.934 14.4167C47.728 14.725 47.4351 14.9654 47.0925 15.1073C46.7499 15.2492 46.3729 15.2863 46.0092 15.214C45.6455 15.1416 45.3114 14.9631 45.0492 14.7008C44.787 14.4386 44.6084 14.1045 44.536 13.7408C44.4637 13.3771 44.5008 13.0001 44.6427 12.6575C44.7846 12.3149 45.025 12.022 45.3333 11.816ZM38.835 19H49.5C50.4943 19.001 51.4475 19.3964 52.1506 20.0994C52.8536 20.8025 53.249 21.7557 53.25 22.75V26.5C53.2493 27.1628 52.9857 27.7983 52.517 28.267C52.0483 28.7357 51.4128 28.9993 50.75 29V34C50.7493 34.6628 50.4857 35.2983 50.017 35.767C49.5483 36.2357 48.9128 36.4993 48.25 36.5H44.5C43.8372 36.4993 43.2017 36.2357 42.733 35.767C42.2643 35.2983 42.0007 34.6628 42 34V26.5H44.5V34H48.25V26.5H50.75V22.75C50.75 22.4185 50.6183 22.1005 50.3839 21.8661C50.1495 21.6317 49.8315 21.5 49.5 21.5H37.665L31.415 14H23.25C22.9185 14 22.6005 14.1317 22.3661 14.3661C22.1317 14.6005 22 14.9185 22 15.25V22.75H24.5V34H29.5V25.25H32V34C31.9993 34.6628 31.7357 35.2983 31.267 35.767C30.7983 36.2357 30.1628 36.4993 29.5 36.5H24.5C23.8372 36.4993 23.2017 36.2357 22.733 35.767C22.2643 35.2983 22.0007 34.6628 22 34V25.25C21.3372 25.2493 20.7017 24.9857 20.233 24.517C19.7643 24.0483 19.5007 23.4128 19.5 22.75V15.25C19.501 14.2557 19.8964 13.3025 20.5994 12.5994C21.3025 11.8964 22.2557 11.501 23.25 11.5H32.585L38.835 19ZM8.3334 14C8.88568 14 9.3334 14.4477 9.3334 15V20.6668H15C15.5523 20.6668 16 21.1145 16 21.6668C16 22.2191 15.5523 22.6668 15 22.6668H9.3334V29C9.3334 29.5523 8.88568 30 8.3334 30C7.78111 30 7.3334 29.5523 7.3334 29V22.6668H1C0.447715 22.6668 0 22.2191 0 21.6668C0 21.1145 0.447715 20.6668 1 20.6668H7.3334V15C7.3334 14.4477 7.78111 14 8.3334 14Z"
                            />
                        </svg>
                        <h2 className="h2">Dodaj osobę powiązaną</h2>
                    </div>
                    <p className="margin-top-32">Osoba powiązana jest to ...</p>
                    <section className="margin-top-32">
                        <form
                            id="add-reletad-form"
                            method="post"
                            action=""
                            onSubmit={(e) => this.save(e)}
                        >
                            <fieldset>
                                <legend className="form__legend">
                                    Kim jesteś dla dodawanej osoby?
                                </legend>
                                <ul className="">
                                    <li className="radio-list-item">
                                        <input
                                            type="radio"
                                            name="relation-relation"
                                            id="relation-rodzic"
                                            className="form__radio"
                                            value="rodzic"
                                            onChange={(e) => {
                                                this.setState({ ParticipantRelationsDVID: 2 });
                                            }}
                                            required
                                        />
                                        <label
                                            htmlFor="relation-rodzic"
                                            className="form__label--radio"
                                        >
                                            Rodzicem
                                        </label>
                                    </li>
                                    <li className="radio-list-item">
                                        <input
                                            type="radio"
                                            name="relation-relation"
                                            id="relation-opiekun"
                                            className="form__radio"
                                            value="opiekun"
                                            onChange={(e) => {
                                                this.setState({ ParticipantRelationsDVID: 1 });
                                            }}
                                        />
                                        <label
                                            htmlFor="relation-opiekun"
                                            className="form__label--radio"
                                        >
                                            Opiekunem
                                        </label>
                                    </li>
                                    <li className="radio-list-item">
                                        <input
                                            type="radio"
                                            name="relation-relation"
                                            id="relation-rodzenstwo"
                                            className="form__radio"
                                            value="rodzenstwo"
                                            onChange={(e) => {
                                                this.setState({ ParticipantRelationsDVID: 3 });
                                            }}
                                        />
                                        <label
                                            htmlFor="relation-rodzenstwo"
                                            className="form__label--radio"
                                        >
                                            Rodzeństwem
                                        </label>
                                    </li>
                                    <li className="radio-list-item">
                                        <input
                                            type="radio"
                                            name="relation-relation"
                                            id="relation-opiekun"
                                            className="form__radio"
                                            value="opiekun"
                                            onChange={(e) => {
                                                this.setState({ ParticipantRelationsDVID: 5 });
                                            }}
                                        />
                                        <label
                                            htmlFor="relation-opiekun"
                                            className="form__label--radio"
                                        >
                                            Dzieckiem
                                        </label>
                                    </li>
                                </ul>
                            </fieldset>
                            <fieldset className="margin-top-32">
                                <legend className="form__legend">Podaj dane dodawanej osoby</legend>

                                <div className="form__row margin-top-16">
                                    <label htmlFor="relation-fname" className="form__label">
                                        Imię<sup> *</sup>
                                    </label>
                                    <input
                                        type="text"
                                        name="relation-fname"
                                        id="relation-fname"
                                        className="form__input"
                                        title="Wpisz swoję imię"
                                        onChange={(e) => {
                                            this.setState({ firstName: e.target.value });
                                        }}
                                        required
                                    />
                                </div>

                                <div className="form__row">
                                    <label htmlFor="relation-lname" className="form__label">
                                        Nazwisko<sup> *</sup>
                                    </label>
                                    <input
                                        type="text"
                                        name="relation-lname"
                                        id="relation-lname"
                                        className="form__input"
                                        title="Wpisz swoję nazwisko"
                                        onChange={(e) => {
                                            this.setState({ lastName: e.target.value });
                                        }}
                                        required
                                    />
                                </div>

                                <div className="form__row">
                                    <fieldset>
                                        <legend className="form__legend">
                                            Płeć<sup> *</sup>
                                        </legend>
                                        <div className="radio-group">
                                            <input
                                                type="radio"
                                                name="relation-gender"
                                                id="relation-gender-female"
                                                className="form__radio"
                                                value="Kobieta"
                                                onChange={(e) => {
                                                    this.setState({ genderDVID: 2 });
                                                }}
                                                required
                                            />
                                            <label
                                                htmlFor="relation-gender-female"
                                                className="form__label--radio"
                                            >
                                                Kobieta
                                            </label>
                                            <input
                                                type="radio"
                                                name="relation-gender"
                                                id="relation-gender-male"
                                                className="form__radio"
                                                value="Mężczyzna"
                                                onChange={(e) => {
                                                    this.setState({ genderDVID: 1 });
                                                }}
                                            />
                                            <label
                                                htmlFor="relation-gender-male"
                                                className="form__label--radio"
                                            >
                                                Mężczyzna
                                            </label>
                                        </div>
                                    </fieldset>
                                </div>

                                <div className="form__row">
                                    <label htmlFor="pesel" className="form__label">
                                        PESEL<sup> *</sup>
                                    </label>

                                    <InputMask
                                        className="form__input"
                                        title="Podaj PESEL"
                                        name="pesel"
                                        mask="99999999999"
                                        maskChar="_"
                                        onChange={(e) => {
                                            this.setState({ pesel: e.target.value });
                                            this.parsePesel(e.target.value)
                                        }}
                                        required
                                    ></InputMask>
                                </div>

                                <div className="form__row">
                                    <label htmlFor="bday" className="form__label">
                                        Data urodzenia (DD.MM.RRRR)<sup> *</sup>
                                    </label>
                                    <input
                                        type="date"
                                        name="bday"
                                        id="bday"
                                        className="form__input"
                                        title="Podaj datę urodzenia"
                                        min="1900-01-01"
                                        max="2100-12-31"
                                        onChange={(e) =>
                                             this.setState({ dateOfBirdth: e.target.value })
                                             
                                        }
                                        value={this.state.value}
                                        disabled={true}
                                        required
                                    />
                                </div>

                                <div className="form__row">
                                    <label htmlFor="relation-street" className="form__label">
                                        Ulica<sup> *</sup>
                                    </label>
                                    <input
                                        type="text"
                                        name="relation-street"
                                        id="relation-street"
                                        className="form__input"
                                        title="Podaj nazwę ulicy"
                                        onChange={(e) => {
                                            this.setState({ street: e.target.value });
                                        }}
                                        required
                                    />
                                </div>

                                <div className="form__row form__row--home-numbers">
                                    <div>
                                        <FilteredInput
                                            label={'Nr domu'}
                                            fieldName={'house'}
                                            title={'Podaj numer domu'}
                                            textMode={true}
                                            timeoutEnabled={false}
                                            onChange={(val) => {
                                                this.setState({ building: val });
                                            }}
                                            charCodeFilter={(charCode) => {
                                                if (
                                                    // numbers
                                                    (charCode >= 48 && charCode <= 57) ||
                                                    // capital letters
                                                    (charCode >= 65 && charCode <= 90) ||
                                                    // small letters
                                                    (charCode >= 97 && charCode <= 122)
                                                ) {
                                                    return true;
                                                } else return false;
                                            }}
                                            required={true}
                                        ></FilteredInput>
                                    </div>

                                    <div>
                                        <FilteredInput
                                            label={'Nr mieszkania'}
                                            fieldName={'flat'}
                                            title={'Podaj numer mieszkania'}
                                            textMode={true}
                                            timeoutEnabled={false}
                                            onChange={(val) => {
                                                this.setState({ flat: val });
                                            }}
                                            charCodeFilter={(charCode) => {
                                                if (
                                                    // numbers
                                                    (charCode >= 48 && charCode <= 57) ||
                                                    // capital letters
                                                    (charCode >= 65 && charCode <= 90) ||
                                                    // small letters
                                                    (charCode >= 97 && charCode <= 122)
                                                ) {
                                                    return true;
                                                } else return false;
                                            }}
                                            required={false}
                                        ></FilteredInput>
                                    </div>
                                </div>

                                <div className="form__row">
                                    <label htmlFor="relation-city" className="form__label">
                                        Miejscowość<sup> *</sup>
                                    </label>
                                    <input
                                        type="text"
                                        name="relation-city"
                                        id="relation-city"
                                        className="form__input"
                                        title="Podaj miasto"
                                        onChange={(e) => {
                                            this.setState({ city: e.target.value });
                                        }}
                                        required
                                    />
                                </div>

                                <div className="form__row">
                                    <label htmlFor="relation-zipcode" className="form__label">
                                        Kod pocztowy<sup> *</sup>
                                    </label>

                                    <InputMask
                                        className="form__input"
                                        title="Podaj kod pocztowy"
                                        name="zipcode"
                                        mask="99-999"
                                        maskChar="_"
                                        onChange={(e) => {
                                            this.setState({ postalCode: e.target.value });
                                        }}
                                        required
                                    ></InputMask>
                                </div>

                                <div className="form__row">
                                    <label htmlFor="relation-mail" className="form__label">
                                        E-mail<sup> *</sup>
                                    </label>

                                    <input
                                        type="email"
                                        name="relation-mail"
                                        id="relation-mail"
                                        className="form__input"
                                        title="Podaj e-mail"
                                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                        onChange={(e) => {
                                            this.setState({ email: e.target.value });
                                        }}
                                        required
                                    />
                                </div>

                                <div className="form__row">
                                    <IntegerInput
                                        label={'Nr telefonu'}
                                        fieldName={'phone'}
                                        title={'Podaj nr telefonu'}
                                        min={0}
                                        max={999999999}
                                        textMode={true}
                                        timeoutEnabled={false}
                                        onChange={(val) => {
                                            this.setState({ phone: val });
                                        }}
                                        required={true}
                                        allowEmptyValue={true}
                                    ></IntegerInput>
                                </div>

                                <div className="form__row">
                                    <p className="checkbox-group">
                                        <input
                                            type="checkbox"
                                            id="relation-agreement"
                                            name="relation-agreement"
                                            className="form__checkbox"
                                            onChange={(e) => {
                                                this.setState({ personalDataProcessingConsent: 1 });
                                            }}
                                            required
                                        />
                                        <label
                                            htmlFor="relation-agreement"
                                            className="form__label--checkbox consent_checkbox"
                                        >
                                            <div>Akceptuję Klauzulę informacyjną RODO:</div>
                                            <ul>
                                                {globals.USER_CONSENTS.map((consent) => (
                                                    <li>{consent}</li>
                                                ))}
                                            </ul>
                                        </label>
                                    </p>
                                    <p className="checkbox-group">
                                        <input
                                            type="checkbox"
                                            id="relation-regulations"
                                            name="relation-regulations"
                                            className="form__checkbox"
                                            required
                                        />
                                        <label
                                            htmlFor="relation-regulations"
                                            className="form__label--checkbox"
                                        >
                                            Akceptuję{' '}
                                            <a
                                                href={globals.TERMS_URL}
                                                className="text-link"
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                Regulamin
                                            </a>
                                        </label>
                                    </p>
                                </div>
                            </fieldset>
                            <input
                                type="submit"
                                className="btn-primary margin-top-32 margin-bottom-32"
                                value="Zatwierdź"
                            />
                        </form>
                    </section>
                </main>
            </>
        );
    }

    formValid(formData) {
        if (!/[0-9]{9}$/.test(formData.phone)) {
            this.notificationService.showError('Nieprawidłowy numer Telefonu');
            return false;
        }

        if (!/[0-9]{11}$/.test(formData.pesel)) {
            this.notificationService.showError('Nieprawidłowy numer PESEL');
            return false;
        }
        if (!/^\d{2}(?:[-\s]\d{3})?$/.test(formData.postalCode)) {
            this.notificationService.showError('Nieprawidłowy kod pocztowy');
            return false;
        }
        if (!/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(formData.email)) {
            this.notificationService.showError('Nieprawidłowy adres E-Mail');
            return false;
        } else {
            return true;
        }
    }

    save(e) {
        e.preventDefault();

        const error = (msg = null) => {
            if (typeof msg === 'string' && msg.length > 0) {
                this.notificationService.showError(msg);
            } else {
                this.notificationService.showError();
            }
        };

        const success = (confirmationNeeded) => {
            if (typeof this.props.finished === 'function') {
                this.props.finished({ confirmationNeeded, personData: formData });
            }
        };

        const formData = {
            ParticipantRelationsDVID: this.state.ParticipantRelationsDVID,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            genderDVID: this.state.genderDVID,
            dateOfBirdth: this.state.dateOfBirdth,
            pesel: this.state.pesel,
            street: this.state.street,
            building: this.state.building,
            flat: this.state.flat,
            city: this.state.city,
            postalCode: this.state.postalCode,
            email: this.state.email,
            phone: this.state.phone,
            personalDataProcessingConsent: this.state.personalDataProcessingConsent,
        };

        if (this.formValid(formData)) {
            this.apiService.apiPost('RegisterSubaccount', formData, (response) => {
                if (response.success) {
                    const messageTxt = globals.getRegistrationTextByStatus(response.data.message);
                    if (response.data.message == 'strUserRegistered') {
                        success(true);
                    } else if (response.data.message == 'strUserRegisteredAndConfirmed') {
                        success(false);
                    } else {
                        // if (response.data.message == 'strAnotherUserWithEmailOrPesel') {
                        // history.push('/osoba_powiazana_error');
                        // } else {
                        error(messageTxt);
                        // }
                    }
                } else {
                    error();
                }
            });
        }
    }
}
